// 流程进度管理 Vuex Module

const state = {
  isFlowActive: false, // 流程是否激活
  isRunning: false, // 流程是否正在运行
  currentStep: -1, // 当前步骤索引
  flowSteps: [
    { id: 'start', label: '开始', type: 'start', status: 'pending' },
    { id: 'entity-analysis', label: '实体关系分析', type: 'process', status: 'pending' },
    { id: 'main-graph', label: '主体图', type: 'process', status: 'pending' },
    { id: 'quick-note-library', label: '秒记库', type: 'process', status: 'pending' },
    { id: 'tag-theme', label: '标签化主体化', type: 'process', status: 'pending' },
    { id: 'end', label: '完成', type: 'end', status: 'pending' }
  ],
  entryList: [], // 白板生成的词条列表
  waitingForBubbleJump: false // 是否等待跳转到气泡图的确认
}

const mutations = {
  // 启动流程
  START_FLOW (state) {
    state.isFlowActive = true
    state.isRunning = true
    // 完成"开始"节点
    state.currentStep = 0
    state.flowSteps[0].status = 'completed'
    // 立即进入第一个处理节点（实体关系分析）
    state.currentStep = 1
    state.flowSteps[1].status = 'running'
  },

  // 暂停流程
  PAUSE_FLOW (state) {
    state.isRunning = false
  },

  // 继续流程
  RESUME_FLOW (state) {
    state.isRunning = true
  },

  // 移动到下一步
  NEXT_STEP (state, payload = {}) {
    const { stepId } = payload
    
    // 完成当前步骤
    if (state.currentStep >= 0 && state.currentStep < state.flowSteps.length) {
      state.flowSteps[state.currentStep].status = 'completed'
    }

    // 如果指定了 stepId，找到对应步骤
    if (stepId) {
      const stepIndex = state.flowSteps.findIndex(step => step.id === stepId)
      if (stepIndex !== -1) {
        state.currentStep = stepIndex
        state.flowSteps[stepIndex].status = 'running'
        return
      }
    }

    // 否则移动到下一步
    state.currentStep++
    if (state.currentStep < state.flowSteps.length) {
      state.flowSteps[state.currentStep].status = 'running'
      
      // 如果是最后一个节点（完成节点），标记流程完成但保持激活
      if (state.currentStep === state.flowSteps.length - 1) {
        state.isRunning = false
        state.isFlowActive = true // 保持激活状态以显示完成效果
      }
    } else {
      // 流程超出范围，完全结束
      state.isRunning = false
      state.isFlowActive = false
    }
  },

  // 完成流程
  COMPLETE_FLOW (state) {
    // 将最后一个节点标记为完成
    if (state.currentStep >= 0 && state.currentStep < state.flowSteps.length) {
      state.flowSteps[state.currentStep].status = 'completed'
    }
    state.isRunning = false
    state.isFlowActive = true // 保持激活状态以显示完成效果
  },

  // 重置流程
  RESET_FLOW (state) {
    state.isFlowActive = false
    state.isRunning = false
    state.currentStep = -1
    state.flowSteps.forEach(step => {
      step.status = 'pending'
    })
  },

  // 更新特定步骤状态
  UPDATE_STEP_STATUS (state, { stepId, status }) {
    const step = state.flowSteps.find(s => s.id === stepId)
    if (step) {
      step.status = status
    }
  },

  // 设置词条列表
  SET_ENTRY_LIST (state, entryList) {
    state.entryList = entryList || []
  },

  // 设置等待跳转气泡图状态
  SET_WAITING_FOR_BUBBLE_JUMP (state, waiting) {
    state.waitingForBubbleJump = waiting
  }
}

const actions = {
  // 启动流程
  startFlow ({ commit }) {
    commit('START_FLOW')
  },

  // 暂停流程
  pauseFlow ({ commit }) {
    commit('PAUSE_FLOW')
  },

  // 继续流程
  resumeFlow ({ commit }) {
    commit('RESUME_FLOW')
  },

  // 移动到下一步
  nextStep ({ commit }, payload) {
    commit('NEXT_STEP', payload)
  },

  // 完成流程
  completeFlow ({ commit }) {
    commit('COMPLETE_FLOW')
  },

  // 重置流程
  resetFlow ({ commit }) {
    commit('RESET_FLOW')
  },

  // 更新步骤状态
  updateStepStatus ({ commit }, payload) {
    commit('UPDATE_STEP_STATUS', payload)
  },

  // 设置词条列表
  setEntryList ({ commit }, entryList) {
    commit('SET_ENTRY_LIST', entryList)
  },

  // 设置等待跳转气泡图状态
  setWaitingForBubbleJump ({ commit }, waiting) {
    commit('SET_WAITING_FOR_BUBBLE_JUMP', waiting)
  }
}

const getters = {
  // 获取当前运行的步骤
  currentRunningStep: state => {
    return state.flowSteps.find(step => step.status === 'running')
  },

  // 获取已完成步骤数
  completedCount: state => {
    return state.flowSteps.filter(step => step.status === 'completed').length
  },

  // 获取总步骤数
  totalCount: state => {
    return state.flowSteps.length
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
